import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { AxiosError } from 'axios'
import axios from '@pepper/utils/src/function/axiosInstance'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IntervalsData } from 'types/roi_intervals'

const _getErrorString = (error: AxiosError<{ description?: string }>) =>
  error.response?.data?.description || 'Something went wrong'

type Props = {
  companyId: string
}

export const useRoiIntervals = ({
  companyId,
}: Props): UseQueryResult<IntervalsData> => {
  return useQuery<IntervalsData>({
    queryKey: ['roi/intervals'],
    queryFn: () => handleApiRequest(companyId),
  })
}

const handleApiRequest = async (companyId: string): Promise<IntervalsData> => {
  if (!companyId) throw new Error('Company ID not found')
  const response = await axios.get<IntervalsData>(
    `${SEO_SERVICE_BASE_URL}/companies/${companyId}/analytics-roi/intervals`
  )
  return response.data
}
